import React, {
	useState
} from 'react';
import { Sort, SortDirection } from './SortListStyles';

const SortList = (props) => {
	const { reverse = false, label, isDisabled, controlled = false, handleSort } = props;
	const [reverseState, setReverse] = useState(reverse);

	const isReverse = controlled ? reverse : reverseState;

	const handleSortClick = () => {
		if (isDisabled) {
			return;
		}
		const isRev = !isReverse;
		if (!controlled) {
			setReverse(isRev);
		}
		handleSort && handleSort(isRev);
	};

	const visualReverse = controlled ? isReverse : !isReverse;

	return (
		<Sort onClick={handleSortClick} isDisabled={isDisabled}>
			<span>{label}</span>
			<SortDirection reverse={visualReverse} />
		</Sort>
	);
};

export default SortList;
